"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var Popup_1 = require("../Popup");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var PopupModal = /** @class */ (function (_super) {
    __extends(PopupModal, _super);
    function PopupModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupModal.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, style = _b.style, modalClassName = _b.modalClassName, modalStyle = _b.modalStyle, paneClassName = _b.paneClassName, paneStyle = _b.paneStyle, title = _b.title, children = _b.children, type = _b.type, open = _b.open, close = _b.close;
        return (React.createElement(Popup_1.default, { onClick: close, className: className, style: style, hide: !open },
            React.createElement("div", { className: classnames_1.default(styles.modal, styles[type], (_a = {}, _a[styles.show] = open, _a), modalClassName), style: modalStyle, onClick: function (e) { return e.stopPropagation(); } },
                React.createElement("div", { className: classnames_1.default(styles.pane, paneClassName), style: paneStyle },
                    title && (React.createElement("h1", { className: styles.title },
                        React.createElement("span", null, title))),
                    children),
                React.createElement(icons_1.CloseIcon, { className: styles.closeButton, onClick: close }))));
    };
    return PopupModal;
}(React.Component));
exports.default = PopupModal;
